var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, property, customElement } from 'lit-element';
let SimpleGreeting = class SimpleGreeting extends LitElement {
    constructor() {
        super(...arguments);
        this.message = '';
        this.date = new Date();
    }
    render() {
        return html `
            <style>
             .communication-overlay {
                background-color: grey;
                position: absolute;
                display: flex;
                flex-direction: column;
                height: 200px;
                width: 290px;
                z-index: 99;
                right: 0;
                top: 200px;
                transition: right 0.2s ease;
            }
            
            .communication-overlay:hover {
                right: 0;
            }
            .communication-overlay.initiator {
                top: 450px;
            }
            
            .communication-overlay__titlebar {
                flex: 0 0 20px;
                background-color: #D73CEA;
                width: 100%;
            }
            
            .communication-overlay__content {
                display: flex;
                flex: 0 0 180px;
            }
            .communication-overlay__content > video {
                flex: 0 0 180px;
            }
            .communication-overlay__commands {
                position: absolute;
                display: flex;
                flex-direction: row;
                justify-content: center;
                flex: 0 0 40px;
                padding: 15px;
                bottom: 0;
                left: 25%;
            }
            
            .communication-overlay__command-item {
                height: 40px;
                width: 40px;
                border-radius: 50%;
                background-repeat: no-repeat;
                background-size: 50%;
                background-position: center;
                cursor: pointer;
            }
            </style>
            <div class="communication-overlay">
                <div class="communication-overlay__titlebar"></div>
                    <div class="communication-overlay__content"></div>
                    <div class="communication-overlay__commands">
                            <div class="communication-overlay__command-item mute" title="Mute your mic"></div>
                            <div class="communication-overlay__command-item hang-up" title="Hang up"></div>
                    </div>
                </div>
            </div>`;
    }
};
__decorate([
    property()
], SimpleGreeting.prototype, "message", void 0);
__decorate([
    property()
], SimpleGreeting.prototype, "date", void 0);
__decorate([
    property()
], SimpleGreeting.prototype, "render", null);
SimpleGreeting = __decorate([
    customElement('cea-video')
], SimpleGreeting);
export { SimpleGreeting };
